<template>
  <div class="spinner-border" :class="{ 'spinner-border-sm': small }" role="status">
    <span class="sr-only">{{ ariaText }}</span>
  </div>
</template>

<script>
  
  export default {
    default: 'Spinner',
    props: {
      ariaText: {
        type: String,
        default: 'Loading...',
      },
      small: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>
